export const adaptUbicacion = (ubicacionData) => {
    return {
        id: ubicacionData?.idUbicacion,
        displayName: ubicacionData?.descripcion,
        name: ubicacionData?.descripcion
    }
}

export const adaptUbicacionArray = (
    ubicaciones
) => {
    return structuredClone(ubicaciones?.allUbicacion)
        ?.map(ubicacion => adaptUbicacion(ubicacion));
}